import React, { useEffect, useState } from "react";

const POSCorpTab = (props) => {
  const [mount, setMount] = useState(false);
  useEffect(() => {
    if (!mount) {
      window.erxesSettings = {
        forms: [
          {
            brand_id: "iaBmBz",
            form_id: "qv7Kva",
          },
        ],
      };

      (function () {
        var script = document.createElement("script");
        script.src =
          "https://widgets.golomtbank.com/build/formWidget.bundle.js";
        script.async = true;

        var entry = document.getElementsByTagName("script")[0];
        entry.parentNode.insertBefore(script, entry);
      })();
    }
  });

  return (
    <div
      data-erxes-embed="qv7Kva"
      style={{ width: "100%", minHeight: "300px" }}
    ></div>
  );
};
export default POSCorpTab;
